/**
 * Created by intellicar-rinas on 20/9/17.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import actions from '../../store/actions';
import './Header.scss'
import Dom from '../../helpers/Dom';
import searchConfig from '../../Layouts/config/searchConfig';
// import {trackTime} from '../../helpers/debugger';
import onRoadIcon from '../../assets/svg/onRoad.svg';
import redIntellicarLogo from '../../assets/svg/Intellicar_Red_logo.svg'
import offRoadIcon from '../../assets/svg/offRoad.svg';
// import logo from '../../assets/svg/logo.svg';
import nh100Logo from '../../assets/images/nh100-logo.png';
import fre8wiseLogo from '../../assets/images/fre8wise-logo.png'
import ioclLogo from '../../assets/images/iocl-logo.png';
import hpeLogo from '../../assets/images/hpe-logo.png';
import flyyLogo from '../../assets/images/flyy-logo.png';
import revvLogo from '../../assets/images/revv-logo.png';
import greenDrive from '../../assets/images/greendrive_logo.svg'
import InPopup from '../InPopup/InPopup';
import UserAPIs from '../../APIs/UserAPIs';
import $ from 'jquery';
import VehicleAPIs from '../../APIs/VehicleAPIs';
import CommandAPIs from '../../APIs/CommandAPIs';
import moment from 'moment';
import { dateFormat } from '../../constants/constants';
import ReactDOM from 'react-dom';
import { save } from '../../helpers/helperFunctions';
import NeverCommGps from '../NeverCommGps/NeverCommGps';
import napino from '../../assets/images/Napino.png';
import moeving from '../../assets/images/moeving.png';
import virya from '../../assets/images/viryaHeaderLogo.svg';
import torklogo from '../../assets/images/torkLogo.png';
import containsLatLng from '../../components/InMap/Map/ContainsLatLng'
import perpetuityLogo from '../../assets/images/PerpetuityCapital_Logo.jpg'
import Biliti_Primary_Logo from '../../assets/images/Biliti_Primary_Logo.svg'
import mondaysLogo from '../../assets/images/mondaywhite.svg'
import ketoLogo from '../../assets/images/keto_logo.png'
import gozapLogo from '../../assets/images/gozap2.png'
import JEM_LOGO_MAIN from '../../assets/images/JEM_LOGO_MAIN.png'
import cruzex from '../../assets/images/cruzex.png'
import easyv_w from '../../assets/images/easyv_w.png'

const loadTime = Date.now();

export const getLogoWidth = () => {
    if(window.isWhiteLabelAvailable('nh100')) {
        return 66
    }else if(window.isWhiteLabelAvailable('iocl')) {
        return 166
    }else if(window.isWhiteLabelAvailable('hpe')) {
        return 146
    }else if(window.isWhiteLabelAvailable('fly')) {
        return 70
    }else if(window.isWhiteLabelAvailable('fre8wise')) {
        return 150
    }else if(window.isWhiteLabelAvailable('napino')) {
        return 170
    }else if(window.isWhiteLabelAvailable('moeving')){
        return 180
    }else if(window.isWhiteLabelAvailable('viryamobility')){
        return 150
    }
    else if(window.isWhiteLabelAvailable('tork')){
        return 120
    }
    else if(window.isWhiteLabelAvailable('perpetuitycapital')){
        return 66
    }
    return 120;
}

const PASS_NO_MATCH_ERR = 'Passwords doesn\'t match';

class ResetPasswordWgt extends Component {
    state = {
        otpWait: false,
        msg: '',
        busy: false,
        passwordErr: '',
        cPasswordErr: '',
        otp: '',
        password: '',
        cPassword: '',
    }
    resetPassword = () => {
        if(this.state.busy) return;
        let { otp, password, cPassword, passwordErr } = this.state;
        if(!otp || !password || passwordErr) return;
        this.setState({ msg: '', busy: true });
        if(password !== cPassword) return this.setState({ busy: false, cPasswordErr: PASS_NO_MATCH_ERR })
        window.grecaptcha.execute('6LczXf0UAAAAAENBT-2jze2A0c_FGMEp90z_13gp', {action: 'resetpassword'}).then(token => {
            UserAPIs.resetPassword({
                username: this.props.email,
                otp,
                password,
                recaptcha: token,
            }).then(() => {
                this.setState({ msg: 'Password successfully changed', otpWait: false })
            }).catch(err => {
                if(err.response) {
                    this.setState({ msg: err.response.data.msg, busy: false })
                }
            })
        })
    };
    sendOtp = () => {
        if(this.state.busy) return;
        this.setState({ msg: '', busy: true });
        window.grecaptcha.execute('6LczXf0UAAAAAENBT-2jze2A0c_FGMEp90z_13gp', {action: 'sendotp'}).then(token => {
            UserAPIs.getEmailOtp({ username: this.props.email, captcha: token }).then(() => {
                this.setState({otpWait: true, busy: false})
            }).catch(err => {
                if(err.response) {
                    this.setState({ msg: 'Send OTP error', busy: false })
                }
            })
        })
    }
    otpChanged = ({target: { value }}) => {
        if(value.length <= 6) {
            this.setState({otp: value.replace(/\D/g, '')});
        }
    }
    // validate password field (onChange handler)
    onPasswordChange = ({target: { value: password }}) => {
        const { cPassword } = this.state;
        const cPasswordErr = cPasswordErr && cPassword !== password ? PASS_NO_MATCH_ERR : '';
        this.setState({ password, cPasswordErr });
        if(password) {
            clearTimeout(this.passwordcheck);
            this.passwordcheck = setTimeout(() => {
                UserAPIs.validatePassword({ username: this.props.email, password }).then(rsp => {
                    this.setState({passwordErr: rsp.data.valid ? '' : rsp.msg});
                });
            }, 250);
        }
    }
    // validate confirm password field (onChange handler)
    onCPasswordChange = ({target: { value: cPassword }}) => {
        this.setState({cPassword, cPasswordErr: cPassword !== this.state.password ? PASS_NO_MATCH_ERR : ''})
    }
    render() {
        let inputHandler = (key, onChange) => {
            if(!onChange) onChange = ({target: { value }}) => this.setState({ [key]: value })
            return {
                onChange,
                value: this.state[key],
                onKeyDown: this.onKeyDown,
            }
        }
        let { busy } = this.state;
        return this.state.otpWait ?
            <div className="hus-form">
                <div className="husf-name">Change Password</div>
                <div className="hus-txt">
                    <div>OTP Sent to</div>
                    <div>{this.props.email}</div>
                </div>
                <input type="text" placeholder="OTP" value={this.state.otp} {...inputHandler('otp', this.otpChanged)} />
                <div className="fld">
                    <input type="password" placeholder="Password" value={this.state.password} {...inputHandler('password', this.onPasswordChange)} />
                    <div className="hus-txt">{this.state.passwordErr}</div>
                </div>
                <div className="fld">
                    <input type="password" placeholder="Confirm password" value={this.state.cPassword} {...inputHandler('cPassword', this.onCPasswordChange)} />
                    <div className="hus-txt mg">{this.state.cPasswordErr}</div>
                </div>
                <button onClick={this.resetPassword} className={busy ? 'disabled' : ''}>Change password</button>
                <div>
                    <div className="hus-txt">{this.state.msg}</div>
                </div>
            </div>
        :
            <div className="hus-form">
                <div className="husf-name">Change Password</div>
                <button onClick={this.sendOtp} className={busy ? 'disabled' : ''}>Change</button>
                <div>
                    <div className="hus-txt">{this.state.msg}</div>
                </div>
            </div>

    }
}

class Header extends Component{

    state = {
        vehicleDataProgress: 0,
        alarmData: [],
        alarmMapData: [],
        showAlertSimButton: true,
        virus: false,
        ncGps: false,
        locZero:false,
        newbucket:false,
        resolvedList: [],
        openBox: false,
        selectedLocation:null,
        panicbtn : false,
        panicViewAll :false,
        enableBtn: false,
    };

    constructor(props){
        super(props);

        this.openUserSettings = () => {
            this.setState({showUserSettings:true, locationUpdateMessage:''});
            this.closeSettings();
        };

        this.closeUserSettings = () => {
            this.setState({showUserSettings:false})
        };

        this.openSettings = () => {
            this.setState({showSettings:!this.state.showSettings})
        };

        this.openSettingPopup = ()=>{
        this.setState({ openBox: true })
        setTimeout(()=>{
            if (this.props.userInfo.SELF) {
                if (this.props.userInfo.SELF.latlng){
                    let lat = parseFloat(this.props.userInfo.SELF.latlng.split(',')[0])
                    let lng = parseFloat(this.props.userInfo.SELF.latlng.split(',')[1])
                    document.getElementById('lat').value = lat
                    document.getElementById('long').value = lng
                }   
            }
        },1000)        
        }
        // this.virusDiv = () => {
        //     this.setState({virus:!this.state.virus});
        //     if(!this.state.virus){
        //         document.getElementsByClassName("inMapDivContainer")[0].style.WebkitFilter = 'blur(6px)';
        //         document.getElementsByClassName("inMapDivContainer")[0].style.filter= 'blur(6px)';          
        //     }
        //     else{
        //         document.getElementsByClassName("inMapDivContainer")[0].style.WebkitFilter = 'blur(0px)';
        //         document.getElementsByClassName("inMapDivContainer")[0].style.filter= 'blur(0px)';   
        //     }
        // }
        this.changeDisplay = () => {
            document.getElementsByClassName("test1").display = 'block';
        }
        this.openNotification =()=> {
            this.setState({showNotification:!this.state.showNotification})
        }

        this.closeSettings = () => {
            this.setState({showSettings:false})
        };

        this.updateLocation = () => {
            let new_location = this.refs.latLng.value;
            if(new_location) {
                new_location = new_location.trim();
                let data = {...this.props.userInfo};
                if(!data.SELF){
                    data.SELF = {};
                }
                data.SELF.latlng = new_location;
                UserAPIs.updateInfo({
                    userid:this.props.auth.userinfo.userid,
                    tag:'SELF',
                    data:data.SELF
                }).then(()=>{
                    this.setState({locationUpdateMessage:'Location updated Successfully'})
                },()=>{
                    this.setState({locationUpdateMessage:'Failed to update Location'})
                })
                this.props.dispatch({
                    type:actions.USERINFO_UPDATED,
                    data
                });
            }
        };

        this.logout = () => {
            window.localStorage.removeItem("checkpath");
            if(this.props.auth.skipImp) {
                let {skipImp, ...auth} = this.props.auth;
                save('intelli-auth', {0: auth});
                window.location.reload();
            } else {
                props.dispatch({type: actions.AUTH_FAILURE})
                window.location.reload();
            }
        };

        this.getDateString =timestamp=> moment(timestamp).format(dateFormat)

        this.getStats = (item) => {
            let limit = 1000 * 60 * 60 * 24 * 2
            let currentDate = Date.now()
            if(this.props.searchResult != null && this.props.searchString !== ""){
                return Object.values(this.props.searchResult).filter(v => {
                    if(item.key === "nocomm_2" && v.filters.includes("nocomm") && (currentDate - v.stats.lasttalkedtime) > limit){
                        return true
                    }
                    else if(v.filters.includes(item.key)){
                        return true
                    }
                }).length
            } 
            // new: change stats count if group selected/unselected
            // TODO: move to backend
            const checkpath = window.localStorage.getItem("checkpath");
            if(checkpath) {
                const groups = JSON.parse(checkpath);
                const gpaths = groups.map(g => g.path);
                return Object.values(this.props.vehicleMap).filter(v => {
                    if(v.filters.includes(item.key)) {
                        const gs = v.groups.map(g => g.path)
                        for(let g of gpaths) {
                            // if(gs.includes(g)) return true;
                            if(gs.includes(g)){
                                if(this.props.roadStats.offroad === true && this.props.roadStats.onroad === false){
                                    if(v.filters.includes('offroad') && v.filters.includes(item.key)){
                                        return true
                                    }
                                }
                                else if(this.props.roadStats.offroad === false && this.props.roadStats.onroad === true){
                                    if(v.filters.includes('onroad') && v.filters.includes(item.key)){
                                        return true
                                    } 
                                } else if(this.props.roadStats.offroad === false && this.props.roadStats.onroad === false){
                                    return false;
                                }
                                else {
                                    return true
                                }
                            }
                        }
                    }
                }).length
            }

            if(item.key === "nocomm_2" && item.nocommnew) {
                
                return Object.values(this.props.vehicleMap).filter(v => {
                    if(v.filters.includes("nocomm") && (currentDate - v.stats.lasttalkedtime) > limit){
                        return true
                    }
                }).length
            }
            

            if(this.props.roadStats.offroad === true && this.props.roadStats.onroad === true){
                return Object.values(this.props.vehicleMap).filter(v => {
                    if(v.filters.includes(item.key)){
                        return true
                    }
                }).length
            }

            if(this.props.roadStats.offroad === true && this.props.roadStats.onroad === false){
                if(this.props.vehicleMap){
                    return Object.values(this.props.vehicleMap).filter(v => {
                        if(v.filters.includes('offroad') && v.filters.includes(item.key)){
                            return true
                        }
                    }).length
                }
            }

            if(this.props.roadStats.offroad === false && this.props.roadStats.onroad === true){
                if(this.props.vehicleMap){
                    return Object.values(this.props.vehicleMap).filter(v => {
                        if(v.filters.includes('onroad') && v.filters.includes(item.key)){
                            return true
                        }
                    }).length
                }
            }

            if(this.props.roadStats.offroad === false && this.props.roadStats.onroad === false){
                return 0;
            }

            return this.props.stats && this.props.stats[item.key] != null ? this.props.stats[item.key] : 0;
        };

        this.toggleOnRoad = () => {
            this.props.dispatch({
                type:actions.TOGGLE_ONROAD
            })
        };

        this.toggleOffRoad = () => {
            this.props.dispatch({
                type:actions.TOGGLE_OFFROAD
            })
        };

        this.applyStatFilter = (item) => {
            if(item.key === "never-comm-gps" ){
                this.setState({
                    ncGps: true,
                    newbucket:true,
                    locZero:false
                })
            }
            else this.setState({
                newbucket:false
            })
            if(item.key === "location-zero"){
                this.setState({
                    newbucket:true,
                    locZero :true,
                    ncGps:false,

                })
            }
            if(item.key === "panicButton") {
                this.setState({panicbtn :true})
            }
            this.props.dispatch({
                type:actions.TOGGLE_STATS_FILTER,
                data:item,
            })
        };
        this.closeNcgps = () =>{
            this.setState({
                newbucket:false,
            })
        }

        this.searchFocus = () => {
            this.refs.search_multi.focus();
        };

        this.search = () => {
            if(this.search_debounce){
                clearTimeout(this.search_debounce);
            }

            this.search_debounce = setTimeout(()=>{
                let str = this.refs.search.value;
                this.props.dispatch({
                    type:actions.SINGLE_SEARCH,
                    data:str != null ? str : ""
                });
            }, searchConfig.singleSearch.deBounceTime)

            let buckets = this.getStatsConfig()
            if(buckets?.[0]){
                this.props.dispatch({
                    type:actions.TOGGLE_STATS_FILTER,
                    data:buckets[0],
                })
            }
        };

        window.setSearchStringAndSearch =str=> {
            this.refs.search.value = str;
            this.search();
        };

        this.updateProgress = (allVehicles) => {
            if(this.props.gotAllBuckets || !allVehicles)
                return;
            let vehicleDataProgress = (allVehicles.length / Object.keys(this.props.vehicleMap).length) * 100;
            this.setState({vehicleDataProgress});
        };

        this.getStatsIcon = item => {
            switch (item.iconType) {
                case 'svg':
                    return <object className={'-'+item.color} data={item.icon}></object>;
                    break;

                case 'text':
                    return <span className={"hc-textIcon -"+item.color}>{item.icon}</span>;
                    break;

                default:
                    return <span className={'hc-classIcon '+item.icon+' -'+item.color}></span>;
            }
        };

        window.onEscape('header-settings', e=>{
            this.closeSettings();
            this.closeUserSettings();
        });

        window.addEventListener('keypress', e=>{
            // forward slash
            if(e.keyCode === 47) {
                e.preventDefault();
                setTimeout(()=>{
                    $(this.refs.search).select();
                    if(this.props.reportWindow.visible) {
                        let search = document.querySelector('.ReportWindow input');
                        if(search && document.activeElement != search) {
                            search.select();
                        }
                    }
                }, 10)
            }
        })

        window.alarmRTSub('header', this.onAlarmRT)
    }

    alarmVehicleCountMap = {};

    isInitialAlarmForVehicle =alarm=> {
        return alarm.time < loadTime // (this.alarmVehicleCountMap[vehicleid] || 0 ) <= 1;
    }

    onAlarmRT =msg=> {

        if(!this.isNotificationShowable())
            return;

        let alarm = msg[0];
        if(!alarm)
            return;

        if(!this.alarmVehicleCountMap[alarm.vehicleid]) {
            this.alarmVehicleCountMap[alarm.vehicleid] = 0;
        }

        this.alarmVehicleCountMap[alarm.vehicleid]++;

        /**
         * 
         *  This code is really inefficient, Wrote it in a hurry :)
         * 
         */

        let alarmMapData = [];
        let adMap = {};
        for(let idx in window.alarmRTData) {
            if(!adMap[window.alarmRTData[idx].alarmType]) {
                adMap[window.alarmRTData[idx].alarmType] = {
                    name: window.alarmRTData[idx].alarmType,
                    children: [],
                    time: 0
                }
            }
            if(window.alarmRTData[idx].time > adMap[window.alarmRTData[idx].alarmType].time) {
                adMap[window.alarmRTData[idx].alarmType].time = window.alarmRTData[idx].time;
            }
            adMap[window.alarmRTData[idx].alarmType].children.push(window.alarmRTData[idx]);
        }
        for(let idx in adMap) {
            alarmMapData.push(adMap[idx])
        }
        this.setState({alarmMapData, alarmData: [...window.alarmRTData]});


        if(!alarm || this.isInitialAlarmForVehicle(alarm))
            return;

        this.props.dispatch({
            type:actions.ADD_INTOAST,
            data:{
                name:(alarm.alarmType||''),
                content:'Vehicle no : ' + alarm.vehicleno + ', Date: '+ alarm.date, 
                createAt:Date.now()
            }
        });
    }

    simAlertList = [
        {name: 'Harsh Acceleration', key: 'harsh_acceleration'},
        {name: 'Harsh Braking', key: 'harsh_braking'},
        {name: 'Harsh Left Turn', key: 'harsh_left_turn'},
        {name: 'Harsh Right Turn', key: 'harsh_right_turn'},  
    ]



    componentWillReceiveProps(props) {
        this.updateProgress(props.stats.allvehicles);
    }

    onSignedIn() {
        localStorage.removeItem("checkpath");
      }
    onSignedOut() {}
    componentDidMount(){
		document.addEventListener('click', this.handleOutsideClick);
        window.addEventListener('mousedown', this.handleCheck)
        window.addEventListener('keydown', this.handleKeyDown)
        if(this.props.statsConfig.length){
            this.props.dispatch({
                type:actions.TOGGLE_STATS_FILTER,
                data:this.props.statsConfig[0],
            });
        }

                window.IntellicarSSOWidget.default.renderProfileSettings("intellicarSSODropWidget",
        {
            onSignedIn: this.onSignedIn,
            onLoggedOut: this.onSignedOut,
        });


    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    }
    handleOutsideClick = e => {
        if(!ReactDOM.findDOMNode(this).contains(e.target)) {
            this.setState({virus:false});
        }
        if(!this.state.virus) {   
            document.getElementsByClassName("inMapDivContainer")[0].style.WebkitFilter = 'blur(0px)';
            document.getElementsByClassName("inMapDivContainer")[0].style.filter= 'blur(0px)';   
          }       
    }
    handleKeyDown = (e) => {
        if(e.keyCode === 27){
            this.setState({openBox: false})
        }
    }
    handleCheck = (e) =>{
        if(ReactDOM.findDOMNode(this.refs.boxContainer) &&!ReactDOM.findDOMNode(this.refs.boxContainer).contains(e.target)) {
        }
        const checkValid = (mapClass) =>{
            if(mapClass.length){
                for(let idx in mapClass){
                    if(mapClass[idx].tagName){
                        if(mapClass[idx].contains(e.target)){
                            return true
                        }
                    } 
                }
                return false
            }else{
                return false
            }
        }

        if(this.refs.boxContainer && !this.refs.boxContainer.contains(e.target)){
            let mapClass =  document.getElementsByClassName("pac-item")
            if(mapClass){
                if(!checkValid(mapClass)) this.setState({openBox:false, selectedLocation:null})
            }
       }
       let pnbClass = document.getElementsByClassName("h-panic-vehicle-list")
       if(!checkValid(pnbClass)) {
        this.setState({panicbtn: false})
       }
    }

    isManageButtonShowable =()=> {
        return this.props.userInfo && this.props.userInfo.SELF && this.props.userInfo.SELF.managementPageButton === 'SHOW';
    };

    getStatsConfig =()=> {
        // console.log(this.props.statsConfig)
        let stats = [];
        for(let idx in this.props.statsConfig) {
            if(!this.props.statsConfig[idx].parent) {
                this.props.statsConfig[idx].children = [];
                stats.push(this.props.statsConfig[idx])
            }
        }

        for(let idx in this.props.statsConfig) {
            if(this.props.statsConfig[idx].parent) {
                for(let jdx in stats) {
                    if(stats[jdx].key === this.props.statsConfig[idx].parent) {
                        stats[jdx].children.push(this.props.statsConfig[idx]);
                    }
                }
            }
        }
        return stats;
    }
     getDefaultMapConfig() {
        let zoom = 11;
        return {
            center: window.locations.USR,
            zoom: zoom,
            // disableDefaultUI:true,
            clickableIcons: false,
            // styles:lightTheme,
            keyboardShortcuts: false
        }
    }

    refLoaded(div) {
        if(div === null)
            return;
        if(div !== null && window.google){
           let searchBox = new window.google.maps.places.SearchBox(document.getElementById('sc-input'));
           searchBox.addListener("places_changed", () => {
            const places = searchBox.getPlaces();
            if(places && places[0]){
                let location = places[0].geometry.location
                let lat = location.lat()
                let lng = location.lng()
                if (document.getElementById("lat")){
                document.getElementById("lat").value  = lat
                document.getElementById("long").value =  lng
                }
                // let loc = {
                //     lat:lat,
                //     lng:lng
                // }
                // this.setState({selectedLocation:loc},() => {
                // })
                let bounds = new window.google.maps.LatLngBounds();
                places.forEach(function (place) {
                    if (place.geometry.viewport) {
                        // Only geocodes have viewport.
                        bounds.union(place.geometry.viewport);
                    } else {
                        bounds.extend(place.geometry.location);
                    }
                });
                if(window.freezMap.active) return;
                window.map.fitBounds(bounds);
            }
           })
        }
    }
    setLocation  () {
        let lat = ''
        let lan = ''
        if(document.getElementById('lat').value){
            lat = document.getElementById('lat').value
        }
        if (document.getElementById('long').value){
            lan = document.getElementById('long').value
        }
        if(!lat){
            document.getElementById("lat").style.border = "1px solid red";
            return
        }
        if(!lan){
            document.getElementById("long").style.border = "1px solid red";
            return
        }
            
       
        if(lat && lan){
            this.setState({ btnBusy: true })
            let data = {
                latlng : lat + "," + lan
            }
            UserAPIs.updateInfo({
                userid:this.props.auth.userinfo.userid,
                tag:'SELF',
                data:data
            }).then((resp) => {
                this.setState({openBox:false, btnBusy: false})
                this.props.dispatch({
                    type:actions.ADD_INTOAST,
                    data:{
                        name: "Default Location Updated",
                        content:"Default location updated", 
                        createAt:Date.now(),
                        autoClose: 8000,
                    }
                });
            }).catch(() =>{
                this.setState({openBox:false, btnBusy: false})
                this.props.dispatch({
                    type:actions.ADD_INTOAST,
                    data:{
                        name: " Location update Failed",
                        content:"Couldn't update the location. Please try again", 
                        createAt:Date.now(),
                        autoClose: 8000,
                    }
                });
            })
        }
    }
    isItemActive =key=> {
        if(!this.props.statsFilter) 
            return false;

        if(this.props.statsFilter.key === key) {
            return true;
        }
        let config = this.getStatsConfig();
        for(let idx in config) {
            if(config[idx].key === key) {
                for(let jdx in config[idx].children) {
                    if(config[idx].children[jdx].key === this.props.statsFilter.key) {
                        return true;
                    }
                } 
            }
        }
    }

    isNotificationShowable =()=> window.isWhiteLabelAvailable('iocl');

    toggleAlertSimBox =()=> this.setState({showAlertSimBox: !this.state.showAlertSimBox})

    getLogo =()=> {
        if(window.isWhiteLabelAvailable('fre8wise')) {
            return <img className='white-labeled-logo' src={fre8wiseLogo}/>
        }
        if(window.isWhiteLabelAvailable('moeving')) {
            return <img className='white-labeled-logo' src={moeving}/>
        }
        if(window.isWhiteLabelAvailable('viryamobility')){
            return <img className='white-labeled-logo' src={virya}/>
        }
        if(window.isWhiteLabelAvailable('tork')) {
            return <img className='white-label-tork' src={torklogo}/>
        }
        if(window.isWhiteLabelAvailable('nh100')) {
            return <img className='white-labeled-logo' src={nh100Logo}/>
        }else
        if(window.isWhiteLabelAvailable('iocl')) {
            return (
                <div className='hl-container'>
                    <img className='white-labeled-logo' src={ioclLogo}/>
                    <div className='hlc-desc'>CVTMS</div>
                </div>
            )
        }else
        if(window.isWhiteLabelAvailable('hpe')) {
            return <img className='white-labeled-logo' src={hpeLogo}/>
        }else
        if(window.isWhiteLabelAvailable('fly')) {
            return <img className='white-labeled-logo' src={flyyLogo}/>
        }else
        if(window.isWhiteLabelAvailable('revv')) {
            return <img className='white-labeled-logo' src={revvLogo}/>
        }else if(window.isWhiteLabelAvailable('napino')){
            return (
                <div className="napinoHeader">
                <img src={redIntellicarLogo}/>
                <img className="n-logo" src={napino}/>
                </div>
            )
        }
        else if(window.isWhiteLabelAvailable('perpetuitycapital')) {
            return <img className='white-labeled-logo' src={perpetuityLogo}/>
        }
        else if(window.isWhiteLabelAvailable('greendrivemobility')) {
            return <img className='gd-logo' src={greenDrive}/>
        }
        else if(window.isWhiteLabelAvailable('bilitielectric')) {
            return <img className='biliti-logo'  src={Biliti_Primary_Logo}/>
        }
        else if(window.isWhiteLabelAvailable('mondays')) {
            return <img className='monday-logo'  src={mondaysLogo}/>
        }
        else if(window.isWhiteLabelAvailable('etomotors')) {
            return <img className='whitelabel-keto'  src={ketoLogo}/>
        }
        else if(window.isWhiteLabelAvailable('gofuel')) {
            return <img className='whitelabel-gozap'  src={gozapLogo}/>
        }
        else if(window.isWhiteLabelAvailable('jupiterelectricmobility')) {
            return <img className='whitelabel-gozap' src={JEM_LOGO_MAIN}/>
        }
        else if(window.isWhiteLabelAvailable('libtracx')) {
            return <img className='whitelabel-libtracx' src={cruzex}/>
        }
        else if(window.isWhiteLabelAvailable('easyv')) {
            return <img className='whitelabel-easyv' src={easyv_w}/>
        }
        
        return <img src={redIntellicarLogo}/>
    }

    toggleAlarm =key=> {
        let alarmExpandedMap = {...(this.state.alarmExpandedMap || {})};
        alarmExpandedMap[key] = !alarmExpandedMap[key];
        this.setState({alarmExpandedMap});
    }

    isAlarmExpanded =key=> {
        return this.state.alarmExpandedMap && this.state.alarmExpandedMap[key]
    }

    sortAlarm =(a,b)=> {
        return b.time - a.time;
    }

    triggerAlarm =alarm=> {
        let vehicleid = Object.keys(this.props.vehicleMap)[0];
        if(!vehicleid)
            return;

        let body = {
            vehicleid,
            command: alarm.key
        }
  
        VehicleAPIs.sendERMESafeCmd(body)
            .then(resp=> {
                console.log("CMD SEND SUCCESS")
            }, resp=> {
                console.log("CMD SEND FAILED")
            })
        
    }

    isPanicButtonListShowable =()=> {
        return this.props.statsFilter && this.props.statsFilter.key === 'panicButton' && this.state.panicbtn;
    }

    getPanicVehicleList =()=> {
        let arr = [];
        let fullList = []
        let resolvedList = JSON.parse( localStorage.getItem('resolvedList'))
        for(let idx in this.props.vehicleMap) {
            if(this.props.vehicleMap[idx].stats && this.props.vehicleMap[idx].stats.panicButton) {
                if(resolvedList && resolvedList.includes(this.props.vehicleMap[idx].vehicleid)){
                    continue
                }
                fullList.push(this.props.vehicleMap[idx]);
                fullList.sort((a,b) => (a.stats.panicButtonTime < b.stats.panicButtonTime) ? 1 : ((b.stats.panicButtonTime < a.stats.panicButtonTime) ? -1 : 0))
                let currentdate = moment(new Date()).unix()*1000
                if(!this.state.panicViewAll && this.props.vehicleMap[idx].stats.panicButtonTime < (currentdate - 1000 * 60 * 60 * 24 * 3)) {
                    continue
                }
                arr.push(this.props.vehicleMap[idx]);
                arr.sort((a,b) => (a.stats.panicButtonTime < b.stats.panicButtonTime) ? 1 : ((b.stats.panicButtonTime < a.stats.panicButtonTime) ? -1 : 0))
            }
        }

        if(arr.length === 0 ) {
            return fullList
        }
        if(!this.state.enableBtn && arr.length)this.setState({enableBtn :true})

        return arr || [];
    }

    resolvePanicButton =vehicle=> {
        let resolvedList = this.state.resolvedList
        //fire api

        if(!vehicle || !vehicle.vehicleid)
            return;

        vehicle.resolvePanicButtonAPIFired = true;
        CommandAPIs.resolvePanicButtonAlert({
            vehicleid: vehicle.vehicleid
        }).then(r=>{
            resolvedList.push(vehicle.vehicleid)
            this.setState({resolvedList: resolvedList})
            localStorage.setItem("resolvedList", JSON.stringify(resolvedList));
        }, r=>{})
        this.forceUpdate();
    }

    /**
     * logout impersonated user
     */
    switchUser = () => {
        this.setState({setBusy: true})
        window.localStorage.removeItem("checkpath");
        if(this.props.auth.skipImp) {
            let {skipImp, ...auth} = this.props.auth
            save('intelli-auth', {0: auth});
            window.location.reload();
        } else {
            UserAPIs.verifyToken().then(resp => {
            this.props.dispatch({type: actions.AUTH_FAILURE})
            window.location.reload();
              }).catch(err=>{
                   localStorage.removeItem('auth-user');
                   this.props.dispatch({type: actions.AUTH_FAILURE})
                  window.location.reload();  
              })
        }
    }

    render(){ 
        let canResetPassword = this.props.userType === 'emailuser' && (!window.originalUser || (window.originalUser && window.originalUser.skipImp));
        return (
            <div className="Header">
                <div className="h-logo">
                    {this.getLogo()}
                </div>
                <div className={"h-search"+(this.props.multiSearchConditions.data.length ? ' multiSearch' : '')}
                        style={{
                            right: (200 + (this.isManageButtonShowable() ? 80 : 0) + (this.getStatsConfig().length * 50)) + 'px',
                            left:  (getLogoWidth())
                        }}>
                    {/*<div className="hs-body">*/}
                        {/*<div className="hsb-backdrop" onClick={this.searchFocus}></div>*/}
                        {/*<input placeholder="Search" ref="search_multi"/>*/}
                    {/*</div>*/}
                    <div className={Dom.Class({'inactive': this.props.gotAllBuckets}, "hs-loading")}>
                        <div className="hsl-spinner"></div>
                        <div className="hsl-name">LOADING</div>
                        <div className="hsl-progress" style={{width:this.state.vehicleDataProgress + '%'}}></div>
                        <div className="hsl-content">
                            <div className="hslc-icon"><i className="fa fa-info-circle"></i></div>
                            <div className="hslc-text">
                                Please wait till all the vehicle data is loaded
                            </div>
                        </div>
                    </div>
                    <div className="hs-body -single">
                        <input placeholder="Search" id='headersearch' onChange={this.search} ref="search"/>
                    </div>
                    {/* <div className="hs-virus">
                            <div className="hsv-icon"><i className="fas fa-virus" onClick={this.virusDiv}></i><span id="corona">Click to prevent Covid-19 infection!!</span> </div>
                            {
                                this.state.virus ? <div className="hsv-expanddiv" >
                                    <div className="hsvi-groupicon">
                                        <div className="name-1" ><div className="highlight"><i className="fal fa-sink"></i></div>
                                           <div className="handwash"><span>5 times a day...</span> </div>
                                        </div>
                                        <div className="name-1"><div className="highlight"><i className="fal fa-hands-wash"></i></div>
                                             <div className="handwash"><span>wash your hands</span></div>
                                        </div>
                                        <div className="name-1"><div className="highlight"><i className="fal fa-soap"></i></div>
                                             <div className="handwash"><span>with soap</span></div>
                                        
                                        </div>
                                        <div className="name-1"><div className="highlight"><i className="fal fa-stopwatch-20"></i></div>
                                            <div className="handwash"><span>for 20 secs.</span></div>
                                        </div>
                                        <div className="name-1" ><div className="highlight"><i className="fal fa-people-arrows"></i></div>
                                           <div className="handwash">
                                                <span>Keep 6 feet distance.</span>
                                            </div>
                                        </div>
                                        <div className="name-1" ><div className="highlight"><i className="fal fa-head-side-cough"></i></div>
                                           <div className="handwash">
                                                <span>Cough into your elbow.</span>
                                            </div>
                                        </div>
                                        <div className="name-1" ><div className="highlight"><i className="fal fa-head-side-mask"></i></div>
                                            <div className="handwash">
                                                <span>Wear mask only if you are travelling in public areas.</span>
                                            </div>
                                        </div>
                                        <div className="name-1" ><div className="highlight"><i className="fal fa-burger-soda"></i></div>
                                            <div className="handwash">
                                                <span>Do not eat outside.</span>
                                            </div>
                                        </div>
                                        <div className="name-1" ><div className="highlight"><i className="fal fa-handshake-slash"></i></div>
                                            <div className="handwash">
                                                <span>Do not shake hands.</span>
                                            </div>
                                        </div>
                                        <div className="name-1" ><div className="highlight"><i className="fal fa-plane-slash"></i></div>
                                            <div className="handwash">
                                                <span>Do not travel.</span>
                                            </div>
                                        </div>
                                        <div className="name-1" ><div className="highlight"><i className="fal fa-house-user"></i></div>
                                           <div className="handwash">
                                                <span>Stay at home.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> : ''
                            }
                    </div> */}
                </div>
                <div className="h-controls" style={{display:'flex',alignItems:'center'}}>
                {this.props && this.props.userInfo && !this.props.userInfo.SELF.hide_all_buckets ?<div className='newSettings'>
                    <button onClick={() => this.openSettingPopup()}><i className='fa fa-cog'></i></button>
                    {this.state.openBox ?
                    <div className='trackSettings'>
                                <span className='setting-close' onClick={() => { this.setState({ openBox: false }) }}>x</span>
                     <div className='setting-heading'>
                         <span>
                             Settings
                         </span>
                     </div>
                       <div className='line'></div>
                     <div className='locationSelect' ref ="boxContainer">
                           <span className='setting-title'>Set user location</span>
                            <div className='ls-box'>  

                                <div className='lsb-search'>
                                    <input id="sc-input" className="inMapSearch"  type="text" placeholder="Search location..."/>
                                    <div className="inMapDiv"  ref={r => this.refLoaded(r)}></div>
                                </div>

                                <div className='latlongContainer'>
                                    <div className='latlong'>
                                                <input style={{ width: '105px' }} id="lat" type="text" placeholder="Latitude"/>
                                                <input style={{ width: '105px', marginLeft: '10px' }} id="long" type="text" placeholder="Longitude"/>
                                     </div>   
                                    <div className="inMapDiv" ref={r => this.refLoaded(r)}></div>
                                </div>

                                <div className='footer'>
                                <button className='lsb-btn' onClick={ () =>this.setLocation()}>
                                {this.state.btnBusy ?<div className='loader'>
                                    <div></div>
                                </div> : "Save"}
                                </button>
                                            <button onClick={() => this.setState({ openBox: false })} style={{ background: "white", color:'#a29a9a', border:'1px solid gray'}} className='lsb-btn'>
                                    Cancel
                                </button>
                                </div>
                            </div>
                            </div>
                     </div>: null}
                </div> :null}
                <div id="intellicarSSODropWidget"></div>
                </div>
                { this.isNotificationShowable() ? (
                    <div className="h-controls">
                        <div className="hc-button" onClick={this.openNotification}>
                            <i className="lnr lnr-alarm"></i>
                            {this.state.alarmData.length ? (
                                <div className='hcb-badge'>{this.state.alarmData.length}</div>
                            ) : ''}
                        </div>
                    </div>
                ) : '' }
                <div className="h-controls">
                    {
                        this.getStatsConfig().map((item,index)=> {
                            return (
                                <div className={Dom.Class({'active':this.isItemActive(item.key)}, "hc-item")}
                                     key={index}>
                                    { this.getStatsIcon(item) }
                                    <div className={"hci-name " + (item.children.length ? ' hasChild' : '') + ' ' + (item.fontColor ? ( '-' + item.fontColor) : '')}>{item.name}</div>
                                    <div className="hci-count">{this.getStats(item)}</div>
                                    <div className="hci-dummy" onClick={()=> this.applyStatFilter(item)}></div>
                                    
                                    {item.children.length ? (
                                        <div className="hci-children">
                                            {item.children.map((child, index2)=>{
                                                return (
                                                    <div key={index2} className={"hcic-child" + (this.props.statsFilter && this.props.statsFilter.key === child.key ? ' active' : '')}>
                                                        <div className="hci-dummy" onClick={()=> this.applyStatFilter(child)}></div>
                                                        { this.getStatsIcon(child) }
                                                        <div className={"hcic-name " + ('-' + item.fontColor)}>{child.name}</div>
                                                        <div className="hci-count">{this.getStats(child)}</div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    ): ''}
                                </div>
                            )
                        })
                    }
                </div>
                {/* {console.log(" header ncgps,loc zero",this.state.ncGps,this.state.locZero,this.state.newbucket)} */}
                {this.state.newbucket ? ( <NeverCommGps ncGps ={this.state.ncGps} locZero={this.state.locZero} newbucket ={this.state.newbucket} closeNcgps={this.closeNcgps}/>):null}
                {this.props && this.props.userInfo && !this.props.userInfo.SELF.hide_all_buckets ?<div className="h-controls">
                    <div className={Dom.Class({'active':this.props.roadStats.onroad}, "hc-toggle-button")}
                         onClick={this.toggleOnRoad}>
                        <div className="hctb-toggle"></div>
                        <object data={onRoadIcon}></object>
                    </div>
                    <div className={Dom.Class({'active':this.props.roadStats.offroad}, "hc-toggle-button")}
                         onClick={this.toggleOffRoad}>
                        <div className="hctb-toggle"></div>
                        <object data={offRoadIcon}></object>
                    </div>
                </div> : null}
                {
                    this.isManageButtonShowable() ? (
                        <a className="h-manage-link" href="https://ams.intellicar.in" target="_blank"><span>MANAGE</span></a>
                    ) : null
                }
                <InPopup  height={550} width={400} visiblity={this.state.showUserSettings} onClose={this.closeUserSettings}>
                    <div className="h-user-settings">
                        <div className="hus-forh">
                        {canResetPassword && <ResetPasswordWgt email={this.props.auth.userinfo.username} />}
                        <div className="hus-form">
                            <div className="husf-name">Default Location</div>
                            <input ref='latLng' placeholder="lat,lng" defaultValue={this.props.userInfo && this.props.userInfo.SELF ? this.props.userInfo.SELF.latlng : ''}/>
                            <button onClick={this.updateLocation}>Update Location</button>
                            <div className="hus-msg">{this.state.locationUpdateMessage}</div>
                        </div>
                        </div>
                        <div className="hus-form">
                            <div className="husf-name">APP UUID</div>
                            <div className="hus-msg">{(window.browser_uuid||{uuid:'NA'}).uuid}</div>
                        </div>
                    </div>
                </InPopup>
                {/* {
                    this.state.showSettings ? (
                        <div className="h-settings-window">
                            <div className="h-settings-backdrop" onClick={this.closeSettings}></div>
                            <div className="h-settings">
                                <div className={'hsw-sect' + (window.originalUser ? ' t2' : '')}>
                                    <div className="hsw-username">
                                        {this.props.auth ? this.props.auth.userinfo.username : 'Please Login Again'}
                                        {window.originalUser && <button className="hsw-reb" onClick={this.openUserSettings}><i className="fa fa-cog"></i></button>}
                                    </div>
                                    {window.originalUser && <div>
                                        <button className="hsw-button" onClick={this.switchUser}>{this.state.setBusy?(<i className="fa fa-refresh fa-spin"></i>):''}{" "}Switch User</button>
                                    </div>}
                                </div>
                                <div className="hsw-sect">
                                    {window.originalUser && <div className="hsw-tx"><i className="fa fa-user-secret"></i> <span>{window.originalUser.userinfo.username}</span></div>}
                                    {!window.originalUser && <div className="hsw-btns">
                                        <button className="hsw-button" onClick={this.openUserSettings}>Settings</button>
                                        <button className="hsw-button" onClick={this.logout}>Logout</button>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    ):null
                } */}

                {
                    this.isNotificationShowable() ? (
                        <div className='h-alert-sim'>
                            <div className='has-button' onClick={this.toggleAlertSimBox}>
                                {this.state.showAlertSimBox ? 'X' : 'SIM'}
                            </div>
                            {this.state.showAlertSimBox ? (
                                <div className='has-container'>
                                    {this.simAlertList.map((button, key)=>{
                                        return (
                                            <div className='hasc-button' onClick={()=>this.triggerAlarm(button)} key={key}>{button.name}</div>
                                        )
                                    })}
                                </div>
                            ) : ''}
                        </div>
                    ) : ''
                }
                {this.isPanicButtonListShowable() ? (
                    <div className='h-panic-vehicle-list'>
                        {this.getPanicVehicleList().map((vehicle, key)=> {
                            return (
                                <div className='hpvl-item' key={key}>
                                    <div className='hpvli-name'>{vehicle.vehicleno}</div>
                                    {vehicle.resolvePanicButtonAPIFired ? (
                                        <div className='hpvli-button -disabled'>RESOLVE <span></span></div>                                    
                                    ) : (
                                        <div className='hpvli-button' onClick={()=>this.resolvePanicButton(vehicle)}>RESOLVE</div>
                                    )}
                                    <div className='hpvli-time'>{this.getDateString(vehicle.stats.panicButtonTime)}</div>
                                </div>
                            )
                        })}
                        {this.state.enableBtn ? <div className='show-btn'>
                            <button onClick={() => {this.setState({panicViewAll:!this.state.panicViewAll})}}>{!this.state.panicViewAll?"Show All": "Show Less"}</button>
                        </div>: null}
                    </div>
                ) : ''}
                {
                    this.state.showNotification ? (
                        (
                            <div className='h-notifications'>
                                <div className='h-notifications-container'>
                                    {this.state.alarmMapData.length ?  this.state.alarmMapData.sort(this.sortAlarm).map((item, key)=> {
                                        return (
                                            <div className='hn-item' key={key}>
                                                <div className='hni-dummy' onClick={()=>this.toggleAlarm(item.name)}></div>
                                                <div className='hni-name'>{item.name}</div>
                                                <div className='hni-count'>{item.children.length}</div>
                                                <div className={'hni-container ' + (this.isAlarmExpanded(item.name) ? ' active' : '')}>
                                                    {item.children.sort(this.sortAlarm).map((alarm, key2)=> {
                                                        return (
                                                            <div className='hnic-alarm' key={key2}>
                                                                <div className='hnica-vehicleno'>{alarm.vehicleno}</div>                                                        
                                                                <div className='hnica-date'>{alarm.date}</div>                                                        
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        )
                                    }) : (
                                        <div className='hn-nodata'>No Alarm Notifications</div>
                                    )}
                                </div>
                            </div>
                        )
                    ) : ''
                }
            </div>
        )
    }

}

const MapPropsToState = (state) => {
    return {
        auth: state.auth,
        stats: state.stats,
        roadStats: state.roadStats,
        reportWindow: state.reportWindow,
        statsFilter: state.statsFilter,
        gotAllBuckets: state.gotAllBuckets,
        vehicleMap: state.vehicleMap,
        userInfo: state.userInfo,
        userType: state.userType,
        multiSearchConditions: state.multiSearchConditions,
        searchResult: state.searchResult,
        searchString: state.searchString,
    }
};

export default connect(MapPropsToState)(Header);
